module.exports = __webpack_public_path__ + "static/media/surfing_pig.f0a58b8b.mp3";